import { render } from "./LanguageMenu.vue?vue&type=template&id=2e4f51ba&ts=true"
import script from "./LanguageMenu.vue?vue&type=script&lang=ts"
export * from "./LanguageMenu.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__